import { gql } from "@apollo/client";

export const GET_ALL_ACTIVITIES = gql`
  query GetAllActivities(
    $take: Int
    $skip: Int
    $inLibrary: Boolean
    $statusView: StatusView
    $cognitiveDomain: CognitiveDomain
    $feature: Feature
  ) {
    voiceMessages(
      data: {
        take: $take
        skip: $skip
        inLibrary: $inLibrary
        statusView: $statusView
        cognitiveDomain: $cognitiveDomain
        feature: $feature
      }
    ) {
      count
      data {
        id
        title
        templateLink
        category
        feature
        focus
        cognitiveDomains
        deletedAt
        createdOn
        difficulty
        recordedBy {
          id
        }
        audioFile {
          id
          durationInSeconds
          filename
          downloadUrl
        }
      }
    }
  }
`;

export const UPLOAD_VOICE_MESSAGE = gql`
  mutation UploadVoiceMessage($file: Upload!, $durationInSeconds: Int!) {
    uploadVoiceMessage(file: $file, durationInSeconds: $durationInSeconds) {
      id
    }
  }
`;

export const GET_DIFFICULTY_ENUMS = gql`
  query GetDifficultyEnums {
    difficultyEnums
  }
`;

/** Keys + labels for activity question blocks (create/edit UI). */
export const GET_QUESTION_TYPES_QUERY = gql`
  query GetQuestionTypes {
    questionTypes {
      id
      questionTypeDescription
      questionTypeKey
      questionTypeLabel
    }
  }
`;

export const GET_DRAFT_ACTIVITIES_QUERY = gql`
  query GetDraftActivities($filter: String) {
    draftActivities(filter: $filter) {
      id
      title
      activityJSON
      updatedAt
    }
  }
`;

export const UPSERT_DRAFT_ACTIVITY_MUTATION = gql`
  mutation UpsertDraftActivity($activityJSON: JSONObject!, $id: Int) {
    upsertDraftActivity(activityJSON: $activityJSON, id: $id) {
      id
      title
      activityJSON
      createdAt
      updatedAt
    }
  }
`;

export const COPY_ACTIVITY_TO_DRAFT = gql`
  mutation CopyActivityToDraft($activityId: Int!) {
    copyActivityToDraft(sourceActivityId: $activityId) {
      id
      title
      activityJSON
    }
  }
`;

export const CREATE_OR_UPDATE_ACTIVITY_MUTATION = gql`
  mutation CreateOrUpdateActivity($input: CreateOrUpdateActivityInput!, $draftId: Int) {
    createOrUpdateActivity(input: $input, draftId: $draftId) {
      id
      title
      category
      difficulty
    }
  }
`;
